import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ItemGroup from "./itemGroup";
import ItemList from "./itemList";
import { TablePagination } from "@mui/material";
import { handleDeleteRowCommon } from "../ItemPageShared/ItemUtils";
// import CartSummary from "./cartSummary";
import { useCart } from "../ItemPageShared/itemContext";
import CheckoutItems from "../ItemPageShared/checkoutitem";
import { BsCart4 } from "react-icons/bs";
import './cardview.css';

const ItemCardView = ({ fetchData,
    // cart,
    // page,
    // setPage,
    // searchResults,
    // setSearchResults,
    rowsPerPage,
    setRowsPerPage,
    itemSearchTerm,
    totalCount,
    handleItemSelect,
    handleDeleteRow
}) => {
    const { GetItemGrp, GetItm } = useSelector((state) => state.itemPage);
    const { cart,page, setPage,
        searchResults, setSearchResults } = useCart();

    useEffect(() => {
        SlicedItem(page, rowsPerPage);
    }, [page, rowsPerPage, GetItm]);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const SlicedItem = (page, rowsPerPage) => {
        if (GetItm && GetItm.length > 0 && !itemSearchTerm) {
            setSearchResults(
                GetItm.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            );
        }
    };
    return (
        <div className="itemDiv d-flex col-10">
            <CheckoutItems/>
            
            <ItemGroup
                fetchData={fetchData}
            />

            <div className="itemDiv col-12 col-sm-9 col-xl-10 col-md-8 col-xxl-10">
                {/* <div className="gradient col-xl-10 col-8"></div> */}
                <ItemList
                    // displayedItem={displayedItem}
                    cart={cart}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    searchResults={searchResults}
                    handleAddCart={handleItemSelect}
                    handleDeleteRow={handleDeleteRow}
                    itemSearchTerm={itemSearchTerm}
                />
                <div className="Cardview-pagination">
                <TablePagination
                    component="div"
                    count={totalCount} // Total count from API response
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                </div>
            </div>
            {/* <CartSummary
                cart={cart}
                // handleCheckout={handleCheckout}
                // setModalShow={setModalShow}
                // showItems={showItems}
                // setIsOtherCustomer={setIsOtherCustomer}
                // isOtherCustomer={isOtherCustomer}
                // setInputValue={setInputValue}
                // inputValue={inputValue}
                // isMobile={isMobile} 
                />  */}

        </div>
    );
}

export default ItemCardView;